module.exports = __webpack_public_path__ + "images/shermin-voshmgir.jpg?v=2c7395c954404f0230d32a05f41ca7aa";